/**
 * Allowed travel tag options for enriched recommendations.
 *
 * These must match the backend's travel_tags allowlist defined in
 * services/db_service.js (or utils/recommendation_payload.js).
 * Update both when the list changes.
 */

export interface RecommendationTag {
  id: string;
  label: string;
}

export const RECOMMENDATION_TRAVEL_TAGS: RecommendationTag[] = [
  { id: 'foodie', label: 'Foodie' },
  { id: 'culture', label: 'Culture' },
  { id: 'adventure', label: 'Adventure' },
  { id: 'wellness', label: 'Wellness' },
  { id: 'luxury', label: 'Luxury' },
  { id: 'budget', label: 'Budget' },
  { id: 'work', label: 'Work' },
  { id: 'celebration', label: 'Celebration' },
  { id: 'family', label: 'Family' },
];

export const RECOMMENDATION_TRAVEL_TAG_IDS = RECOMMENDATION_TRAVEL_TAGS.map((t) => t.id);
